var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kgk-account-activate"},[_c('h1',[_vm._v("Accountaktivierung")]),_c('div',{staticClass:"spacer"}),(_vm.loading)?_c('div',{staticClass:"kgk-loading-indicator"},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_vm._e(),(_vm.error)?_c('div',[_c('p',[_vm._v("Fehler: "+_vm._s(_vm.error))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }